import React from 'react'
import PropTypes from 'prop-types'

class Field extends React.Component {
  constructor (props) {
    super(props)

    const floatLabel = !(this.props.value && this.props.value.length > 0)
    this.state = {
      isEmpty: floatLabel,
      labelFloated: !floatLabel
    }

    this.handleBlur = this.handleBlur.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleFocus = this.handleFocus.bind(this)
  }

  handleBlur () {
    this.setState({ labelFloated: !this.state.isEmpty })
  }

  handleChange (event) {
    if (event.elementType) {
      // Stripe Elements
      this.setState({ isEmpty: event.empty })
    } else {
      this.setState({ isEmpty: !(event.target && event.target.value) })
    }

    if (this.props.onChange) this.props.onChange(event)
  }

  handleFocus () {
    this.setState({ labelFloated: true })
  }

  render () {
    const {
      as: Component,
      label,
      error,
      htmlFor,
      className: classNameProp,
      onChange,
      ...rest
    } = this.props

    let className = 'Field'
    className += this.props.disabled ? ' Field--disabled' : ''
    className += this.state.labelFloated ? ' Field--labelFloated' : ''
    className += error ? ' Field--error' : ''
    className += classNameProp ? ' ' + classNameProp : ''

    return (
      <div className={className}>
        <label htmlFor={htmlFor} style={{ width: '100%' }}>
          <div className='Field__label'>{label}</div>
          <Component
            className='Field__input'
            onBlur={this.handleBlur}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            {...rest}
          />
        </label>
      </div>
    )
  }
}

Field.propTypes = {
  as: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
  className: PropTypes.string,
  error: PropTypes.bool,
  htmlFor: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  autoComplete: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string
}

export default Field
